import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { eventpageResponse } from './models/eventpage-response.model';
import { eventpageModel } from './models/eventpage.model';


@Injectable({
  providedIn: 'root',
})
export class eventpageService extends BaseGQLService<eventpageResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: eventpageModel,
        clientName: 'eventpageService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryEventsPageContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState,
    );
  }


}


